import { render, staticRenderFns } from "./DialogDataTable.vue?vue&type=template&id=66f409c8"
import script from "./DialogDataTable.vue?vue&type=script&lang=ts"
export * from "./DialogDataTable.vue?vue&type=script&lang=ts"
import style0 from "./DialogDataTable.vue?vue&type=style&index=0&id=66f409c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports